import * as React from "react";

const AiSettingsIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      stroke="#334155"
      strokeWidth={1.111}
      d="M18.334 5.558H8.889m0 0a2.222 2.222 0 1 0-4.444 0m4.444 0a2.222 2.222 0 1 1-4.444 0m0 0H1.667m16.667 8.89h-2.778m0 0a2.222 2.222 0 1 0-4.445 0m4.445 0a2.222 2.222 0 1 1-4.445 0m0 0H1.667"
    />
  </svg>
);
export default AiSettingsIcon;
